import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap, CreditCard, CheckCircle2, Sparkles } from 'lucide-react';
const useCountdown = () => {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 47,
    seconds: 46
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let s = prev.seconds - 1;
        let m = prev.minutes;
        let h = prev.hours;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return time;
};
const pad = (n: number) => n.toString().padStart(2, '0');
const CountdownBlock = ({
  value,
  label
}: {
  value: string;
  label: string;
}) => <div className="flex flex-col items-center rounded-[12px] border-2 border-[#A855F7] bg-white px-4 py-3 shadow-sm sm:px-5" data-id="element-165">
    <span className="font-heading text-3xl font-black tabular-nums text-violet-gradient sm:text-4xl" data-id="element-166">
      {value}
    </span>
    <span className="mt-1 text-[10px] font-bold uppercase tracking-wider text-[#1A0A2E]" data-id="element-167">
      {label}
    </span>
  </div>;
export const Pricing = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const handleBuyBase = () => {
    window.location.href = 'https://www.nexorecursos.com/cart/52650829185300:1';
  };
  const handleBuyPro = () => {
    window.location.href = 'https://www.nexorecursos.com/cart/52650831053076:1';
  };
  return <section id="pricing" className="relative w-full bg-[#1A0A2E] py-12 sm:py-16 md:py-20 overflow-hidden" data-id="element-168">
      {/* Radial glow */}
      <div className="pointer-events-none absolute inset-0 z-0" data-id="element-169">
        <div className="absolute left-1/2 top-1/2 h-[600px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[rgba(124,58,237,0.20)] blur-[150px]" data-id="element-170" />
      </div>

      <div className="relative z-10 mx-auto max-w-[720px] px-5" data-id="element-171">
        <div className="mb-12 text-center" data-id="element-172">
          <span className="mb-4 inline-block rounded-full bg-[#EDE9FF] px-3 py-1 text-xs font-bold uppercase tracking-wide text-[#6B21A8]" data-id="element-173">
            ELEGÍ TU KIT
          </span>
          <h2 className="font-heading text-3xl font-bold text-white sm:text-4xl md:text-5xl" data-id="element-174">
            Invertí Una Vez.
            <br data-id="element-175" />
            <span className="text-violet-gradient" data-id="element-176">
              Resultados Para Siempre.
            </span>
          </h2>
        </div>

        {/* Countdown Block */}
        <div className="mx-auto mb-12 max-w-[500px] rounded-[20px] bg-white p-6 shadow-card-featured sm:p-8 relative" data-id="element-177">
          <div className="absolute inset-0 rounded-[20px] border border-[#A855F7]/50 shadow-[0_0_20px_rgba(124,58,237,0.3)] pointer-events-none" data-id="element-178" />
          <p className="text-center text-xs font-bold uppercase tracking-wider text-[#6B21A8] sm:text-sm" data-id="element-179">
            🔥 LANZAMIENTO TERMINA EN
          </p>

          <div className="mt-5 flex items-center justify-center gap-2 sm:gap-3" data-id="element-180">
            <CountdownBlock value={pad(hours)} label="Horas" data-id="element-181" />
            <span className="font-heading text-2xl font-black text-[#D4A017] sm:text-3xl" data-id="element-182">
              :
            </span>
            <CountdownBlock value={pad(minutes)} label="Min" data-id="element-183" />
            <span className="font-heading text-2xl font-black text-[#D4A017] sm:text-3xl" data-id="element-184">
              :
            </span>
            <CountdownBlock value={pad(seconds)} label="Seg" data-id="element-185" />
          </div>

          <p className="mt-5 text-center text-sm font-bold text-[#DC2626] sm:text-base" data-id="element-186">
            ⚠️ +$8.000 DESPUÉS — Y no vuelve a bajar
          </p>

          <div className="mt-6" data-id="element-187">
            <div className="mb-2 flex items-center justify-between text-xs font-bold sm:text-sm" data-id="element-188">
              <span className="text-[#1A0A2E]" data-id="element-189">Cupos restantes</span>
              <span className="text-[#6B21A8]" data-id="element-190">68% TOMADOS</span>
            </div>
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-[#EDE9FF]" data-id="element-191">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.1,
              ease: 'easeOut'
            }} className="h-full rounded-full bg-violet-gradient shadow-[0_0_10px_rgba(124,58,237,0.5)]" data-id="element-192" />
            </div>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:items-stretch" data-id="element-193">
          {/* Base Card */}
          <div className="flex flex-col rounded-[20px] border border-[#A855F7]/30 bg-white p-6 shadow-card-light sm:p-8" data-id="element-194">
            <h3 className="font-heading text-xl font-bold text-[#1A0A2E]" data-id="element-195">
              KIT HIJOS EN CALMA™ 2026
            </h3>
            <p className="mt-1 text-sm text-[#9B8EC4]" data-id="element-196">3 Tomos + 3 Bonos</p>

            <ul className="mt-6 flex flex-col gap-3" data-id="element-197">
              <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-198">
                <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-199" /> 3 Tomos
                completos
              </li>
              <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-200">
                <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-201" /> 3 Bonos
                gratis
              </li>
              <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-202">
                <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-203" /> Acceso
                inmediato
              </li>
            </ul>

            <div className="my-6 h-px w-full bg-[#A855F7]/20" data-id="element-204" />

            <div className="mt-auto" data-id="element-205">
              <p className="text-sm text-[#9B8EC4] line-through" data-id="element-206">$38.990</p>
              <p className="font-heading text-4xl font-bold text-[#1A0A2E]" data-id="element-207">
                $19.990
              </p>
              <p className="mt-1 text-[10px] text-[#9B8EC4]" data-id="element-208">Precio base</p>

              <button onClick={handleBuyBase} className="mt-6 w-full rounded-xl border-2 border-[#6B21A8] py-3 text-sm font-bold text-[#6B21A8] transition-colors hover:bg-[#F8F6FF]" data-id="element-209">
                ELEGIR ESTE KIT →
              </button>
            </div>
          </div>

          {/* PRO Card */}
          <div className="relative md:scale-[1.03] z-10" data-id="element-210">
            <div className="absolute -top-4 left-1/2 z-20 -translate-x-1/2" data-id="element-211">
              <span className="whitespace-nowrap rounded-full bg-gold-gradient px-4 py-1.5 text-xs font-bold text-[#1A0A2E] shadow-lg" data-id="element-212">
                ⭐ MÁS ELEGIDO
              </span>
            </div>

            <div className="relative flex h-full flex-col rounded-[20px] bg-white p-[2px] shadow-card-featured" data-id="element-213">
              <motion.div className="absolute inset-0 rounded-[20px] bg-gold-gradient opacity-50" animate={{
              opacity: [0.3, 0.6, 0.3]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-214" />
              <div className="relative flex h-full flex-col rounded-[18px] bg-white p-6 sm:p-8" data-id="element-215">
                <Sparkles size={20} className="absolute right-4 top-4 text-[#D4A017]" data-id="element-216" />

                <h3 className="font-heading text-2xl font-bold text-[#1A0A2E]" data-id="element-217">
                  KIT COMPLETO
                </h3>
                <p className="mt-1 text-sm text-[#9B8EC4]" data-id="element-218">
                  3 Tomos + 3 Bonos + PRO™
                </p>

                <div className="mt-4 inline-block w-max rounded-full bg-[#ECFDF5] px-3 py-1 text-xs font-bold text-[#059669]" data-id="element-219">
                  ✅ AHORRÁS $19.000
                </div>

                <ul className="mt-6 flex flex-col gap-3" data-id="element-220">
                  <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-221">
                    <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-222" /> Todo
                    el Kit base
                  </li>
                  <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-223">
                    <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-224" /> 50
                    páginas de sistema PRO
                  </li>
                  <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-225">
                    <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-226" /> Los 8
                    miedos resueltos
                  </li>
                  <li className="flex items-center gap-2 text-[15px] text-[#1A0A2E]" data-id="element-227">
                    <CheckCircle2 size={18} className="text-[#6B21A8]" data-id="element-228" /> Plan
                    maestro 60 días
                  </li>
                </ul>

                <div className="my-6 h-px w-full bg-violet-gradient" data-id="element-229" />

                <div className="mt-auto" data-id="element-230">
                  <p className="text-sm text-[#9B8EC4] line-through" data-id="element-231">$46.990</p>
                  <p className="text-shadow-violet font-heading text-5xl font-black text-violet-gradient" data-id="element-232">
                    $27.990
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main CTA */}
        <div className="mt-12 text-center" data-id="element-233">
          <motion.button onClick={handleBuyPro} whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0 8px 32px rgba(212,160,23,0.35)', '0 8px 48px rgba(245,200,66,0.55)', '0 8px 32px rgba(212,160,23,0.35)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="flex h-[68px] w-full items-center justify-center rounded-[14px] bg-gold-gradient px-6 text-lg font-bold uppercase tracking-wide text-[#1A0A2E] sm:text-xl" data-id="element-234">
            💥 SÍ, QUIERO EL KIT COMPLETO — $27.990
          </motion.button>
          <p className="mt-4 text-xs text-[#F8F6FF] sm:text-sm" data-id="element-235">
            Acceso inmediato · PDF · Sin suscripción
          </p>
        </div>

        {/* Trust Row */}
        <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-236">
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-237">
            <Lock size={14} data-id="element-238" /> Pago seguro
          </span>
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-239">
            <Zap size={14} data-id="element-240" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-241">
            <ShieldCheck size={14} data-id="element-242" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#2D1454] px-4 py-2 text-xs text-white" data-id="element-243">
            <CreditCard size={14} data-id="element-244" /> Mercado Pago
          </span>
        </div>

        {/* Guarantee Block */}
        <div className="mx-auto mt-12 max-w-[500px] rounded-[20px] bg-white p-6 text-center shadow-card-light relative sm:p-8" data-id="element-245">
          <div className="absolute inset-0 rounded-[20px] border border-[#A855F7]/30 shadow-[0_0_20px_rgba(124,58,237,0.15)] pointer-events-none" data-id="element-246" />
          <ShieldCheck size={48} className="mx-auto mb-4 text-[#6B21A8]" data-id="element-247" />
          <h3 className="font-heading text-xl font-bold text-[#1A0A2E] sm:text-2xl" data-id="element-248">
            GARANTÍA TOTAL 7 DÍAS
          </h3>
          <p className="mt-2 text-[15px] text-[#4B3B6B]" data-id="element-249">
            Si no es lo que esperabas, te devolvemos el 100%. Sin preguntas. Sin
            formularios. Sin drama.
          </p>
          <p className="mt-4 text-xs italic text-[#6B21A8]" data-id="element-250">
            Tasa de devoluciones: menos del 1%
          </p>
        </div>
      </div>
    </section>;
};